export default "__VITE_ASSET__DKVzHwDd__"